import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import theme from '../../theme';
import { Flex, Text } from '@chakra-ui/react';
import { styles } from './sso-login-styles';
import LoadingOverlay from '../../components/loader-overlay/loader-overlay';
const classes = styles();
const SSOLogin = (props)=>{
    const { loading, match, loginViaSSO, exchangeTokenSso } = props;
    const hash = window.location.hash.substr(1);
    let idToken = '';
    const searchParams = new URLSearchParams(hash);
    idToken = searchParams.get('id_token') ?? '';
    const orgCode = match?.params?.orgCode?.toUpperCase();
    const handleLogin = ()=>{
        loginViaSSO({
            orgCode
        });
    };
    useEffect(()=>{
        if (idToken.length > 0) {
            exchangeTokenSso(idToken);
        }
    }, [
        idToken,
        exchangeTokenSso
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: loading ? /*#__PURE__*/ _jsx("div", {
            className: "centered-application",
            children: /*#__PURE__*/ _jsx("div", {
                className: "centered-application-wrapper",
                children: /*#__PURE__*/ _jsx(LoadingOverlay, {
                    loadingMsg: "Logging you in..."
                })
            })
        }) : /*#__PURE__*/ _jsxs(Flex, {
            className: "sso-form",
            sx: classes.ssoForm,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    sx: classes.ssoFormText,
                    children: "Please click the login button below to authenticate with your organization. Once authenticated, you will be redirected back to CodaMetrix and automatically logged into the application."
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    className: "form-row",
                    sx: classes.btnHeader,
                    children: /*#__PURE__*/ _jsx(Button, {
                        className: "qa-sso-button",
                        size: ButtonSize.MD,
                        label: 'Login',
                        backgroundColor: theme.colors.accent[100],
                        color: theme.colors.text['light'],
                        disabled: loading,
                        name: "SSO Login",
                        dataTestId: "sso_login",
                        onClick: handleLogin
                    })
                })
            ]
        })
    });
};
SSOLogin.displayName = 'SSOLogin';
export default SSOLogin;
